import React from 'react';
import { useNavigate } from 'react-router-dom';

export const CrisisRedirectBanner = () => {
  const navigate = useNavigate();
  return (
    <div
      className="p-5 rounded-2xl mb-8 text-left"
      style={{ background: 'rgba(232,180,184,0.08)', border: '1px solid rgba(232,180,184,0.3)' }}
      data-testid="crisis-redirect-banner"
    >
      <p className="text-sm leading-relaxed mb-3" style={{ fontFamily: 'Jost, sans-serif', color: '#1A1A2E' }}>
        What you shared matters, and you deserve real human support right now — more than this space can give.
      </p>
      <ul className="text-sm space-y-1.5 mb-3" style={{ fontFamily: 'Jost, sans-serif', color: '#A9756B' }}>
        <li>• Call or text <strong>988</strong> — Suicide and Crisis Lifeline, 24/7</li>
        <li>• Text <strong>HOME</strong> to <strong>741741</strong> — Crisis Text Line</li>
        <li>• Call <strong>1-800-799-7233</strong> — National Domestic Violence Hotline</li>
      </ul>
      <button
        onClick={() => navigate('/crisis-resources')}
        className="text-xs underline"
        style={{ fontFamily: 'Jost, sans-serif', color: '#6B6878' }}
        data-testid="crisis-resources-link"
      >
        See all crisis resources
      </button>
    </div>
  );
};
